<template>
  <div ref="chartsData" class="chartsData"></div>
</template>
<script>
import DataService from '@/api/data';
import {utils} from "@/utils/index";
export default {
    name:"TrafficStatistics",
    props:{
        serialNumber:String,
        month:null
    },
    data(){
        return{
            chartsData:'',
            dataList:[],
            date:[],
            send:[],
            total:[],
            receive:[]
        }
    },
    methods:{
        getGatewayFlow(){
            DataService.getGatewayFlow({
               serialNumber:this.serialNumber,
               user_id:this.$store.state.user_id,
               month:this.month 
            }).then(res=>{
                this.date = [];
                this.send = [];
                this.receive = [];
                this.total = [];
                this.dataList = res.data.result;
                this.dataList.forEach(item=>{
                    this.date.push(item.date)
                    this.send.push(item.send)
                    this.receive.push(item.receive)
                    this.total.push(item.total)
                })
                this.date = this.date.map(item=>{
                    return String(item).substring(0,4) + '-' + String(item).substring(4,6) + '-' + String(item).substring(6,8)
                })
                this.getChartData()
            }).catch(err=>{
                this.$message.error(err.message)
            })
        },
        getChartData(){
            let _this = this;
            this.date = [];
            this.date = utils.getDaysInMonth(this.month.substring(0,4),this.month.substring(4,6));
            this.chartsData = this.$echarts.init(this.$refs.chartsData);
            window.addEventListener('resize', function () { _this.chartsData.resize() })
            let option = {
                tooltip: {
                    trigger:'axis',
                    axisPointer: {
                        type: "shadow"
                    },
                    formatter (params) {
                        return `
                        <div style="text-align:center;">
                            <div>${params[0].name}</div>
                            <div>总流量:${(params[2].value/1024/1024).toFixed(1)}MiB</div>
                            <div>上行:${(params[0].value/1024/1024).toFixed(1)}MiB</div>
                            <div>下行:${(params[1].value/1024/1024).toFixed(1)}MiB</div>
                        </div>
                        `
                    }
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                xAxis: [
                    {
                        type: 'category',
                        data: this.date,
                    },
                    {
                        type: 'category',
                        axisLine: {show: false},
                        axisTick: {show: false},
                        axisLabel: {show: false},
                        splitArea: {show: false},
                        splitLine: {show: false},
                        data: this.date
                    },
                ],
                yAxis: [
                    {
                        type: 'value',
                        axisLabel:{
                            formatter: function (value) {
                                return value/1000000 + 'MiB';
                            }
                        }
                    }
                ],
                series: [
                    {
                        name: '上行',
                        type: 'bar',
                        stack: '流量',
                        itemStyle: {
                           normal:{
                               borderRadius: [0, 0, 25, 25],
                                color: new this.$echarts.graphic.LinearGradient(
                                    0, 0, 0, 1,
                                    [
                                        {offset: 0, color: '#83bff6'},
                                        {offset: 0.5, color: '#188df0'},
                                        {offset: 1, color: '#188df0'}
                                    ]
                                )
                           }
                        },
                        data: this.receive
                    },
                    {
                        name: '下行',
                        type: 'bar',
                        stack: '流量',
                        itemStyle: {
                            normal:{
                                borderRadius: [25, 25, 0, 0],
                                color: new this.$echarts.graphic.LinearGradient(
                                    0, 0, 0, 1,
                                    [
                                        {offset: 0, color: '#EEA766'},
                                        {offset: 0.5, color: '#F78D75'},
                                        {offset: 1, color: '#F27190'}
                                    ]
                                ),
                            }
                        },
                        data: this.send
                    },
                    {
                        name: '总流量',
                        type: 'bar',
                        xAxisIndex: 1,
                        itemStyle: {
                            normal:{
                                color: new this.$echarts.graphic.LinearGradient(
                                    0, 0, 0, 0,
                                    [
                                        {offset: 0, color: '#EEA766'},
                                        {offset: 0.5, color: '#F78D75'},
                                        {offset: 1, color: '#F27190'}
                                    ]
                                ),
                            }
                        },
                        data: this.total
                    },
                ]
            };

            this.chartsData.setOption(option);
        }
    },
    mounted(){
    },
    watch:{
        serialNumber(){
            if(this.month != undefined){
                this.getGatewayFlow();
            }
        },
        month(){
            console.log(this.month)
            this.getGatewayFlow();
        }
    }
}
</script>

<style scoped>
.chartsData{
    width: 100%;
    height: 280px;
}
</style>